/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-29.
 * Hardcoded data for general selects
 */
export const COUNTRY_LIST = {
    items: [
        { "id": 'Afganistán', "name": "Afganistán" },
        { "id": 'Albania', "name": "Albania" },
        { "id": 'Alemania', "name": "Alemania" },
        { "id": 'Andorra', "name": "Andorra" },
        { "id": 'Angola', "name": "Angola" },
        { "id": 'Anguila', "name": "Anguila" },
        { "id": 'Antártida', "name": "Antártida" },
        { "id": 'Antigua y Barbuda', "name": "Antigua y Barbuda" },
        { "id": 'Arabia Saudí', "name": "Arabia Saudí" },
        { "id": 'Argelia', "name": "Argelia" },
        { "id": 'Argentina', "name": "Argentina" },
        { "id": 'Armenia', "name": "Armenia" },
        { "id": 'Aruba', "name": "Aruba" },
        { "id": 'Australia', "name": "Australia" },
        { "id": 'Austria', "name": "Austria" },
        { "id": 'Azerbaiyán', "name": "Azerbaiyán" },
        { "id": 'Bahamas', "name": "Bahamas" },
        { "id": 'Bangladesh', "name": "Bangladesh" },
        { "id": 'Barbados', "name": "Barbados" },
        { "id": 'Baréin', "name": "Baréin" },
        { "id": 'Bélgica', "name": "Bélgica" },
        { "id": 'Belice', "name": "Belice" },
        { "id": 'Benín', "name": "Benín" },
        { "id": 'Bermudas', "name": "Bermudas" },
        { "id": 'Bielorrusia', "name": "Bielorrusia" },
        { "id": 'Bolivia', "name": "Bolivia" },
        { "id": 'Bosnia-Herzegovina', "name": "Bosnia-Herzegovina" },
        { "id": 'Botsuana', "name": "Botsuana" },
        { "id": 'Brasil', "name": "Brasil" },
        { "id": 'Brunéi', "name": "Brunéi" },
        { "id": 'Bulgaria', "name": "Bulgaria" },
        { "id": 'Burkina Faso', "name": "Burkina Faso" },
        { "id": 'Burundi', "name": "Burundi" },
        { "id": 'Bután', "name": "Bután" },
        { "id": 'Cabo Verde', "name": "Cabo Verde" },
        { "id": 'Camboya', "name": "Camboya" },
        { "id": 'Camerún', "name": "Camerún" },
        { "id": 'Canadá', "name": "Canadá" },
        { "id": 'Caribe neerlandés', "name": "Caribe neerlandés" },
        { "id": 'Ceuta y Melilla', "name": "Ceuta y Melilla" },
        { "id": 'Chad', "name": "Chad" },
        { "id": 'Chile', "name": "Chile" },
        { "id": 'China', "name": "China" },
        { "id": 'Chipre', "name": "Chipre" },
        { "id": 'Ciudad del Vaticano', "name": "Ciudad del Vaticano" },
        { "id": 'Colombia', "name": "Colombia" },
        { "id": 'Comoras', "name": "Comoras" },
        { "id": 'Congo Brazzaville', "name": "Congo Brazzaville" },
        { "id": 'Corea del Norte', "name": "Corea del Norte" },
        { "id": 'Corea del Sur', "name": "Corea del Sur" },
        { "id": 'Costa de Marfil', "name": "Costa de Marfil" },
        { "id": 'Costa Rica', "name": "Costa Rica" },
        { "id": 'Croacia', "name": "Croacia" },
        { "id": 'Cuba', "name": "Cuba" },
        { "id": 'Curazao', "name": "Curazao" },
        { "id": 'Diego García', "name": "Diego García" },
        { "id": 'Dinamarca', "name": "Dinamarca" },
        { "id": 'Dominica', "name": "Dominica" },
        { "id": 'Ecuador', "name": "Ecuador" },
        { "id": 'Egipto', "name": "Egipto" },
        { "id": 'El Salvador', "name": "El Salvador" },
        { "id": 'Emiratos Árabes Unidos', "name": "Emiratos Árabes Unidos" },
        { "id": 'Eritrea', "name": "Eritrea" },
        { "id": 'Eslovaquia', "name": "Eslovaquia" },
        { "id": 'Eslovenia', "name": "Eslovenia" },
        { "id": 'España', "name": "España" },
        { "id": 'Estados Unidos', "name": "Estados Unidos" },
        { "id": 'Estonia', "name": "Estonia" },
        { "id": 'Etiopía', "name": "Etiopía" },
        { "id": 'Filipinas', "name": "Filipinas" },
        { "id": 'Finlandia', "name": "Finlandia" },
        { "id": 'Fiyi', "name": "Fiyi" },
        { "id": 'Francia', "name": "Francia" },
        { "id": 'Gabón', "name": "Gabón" },
        { "id": 'Gambia', "name": "Gambia" },
        { "id": 'Georgia', "name": "Georgia" },
        { "id": 'Ghana', "name": "Ghana" },
        { "id": 'Gibraltar', "name": "Gibraltar" },
        { "id": 'Granada', "name": "Granada" },
        { "id": 'Grecia', "name": "Grecia" },
        { "id": 'Groenlandia', "name": "Groenlandia" },
        { "id": 'Guadalupe', "name": "Guadalupe" },
        { "id": 'Guam', "name": "Guam" },
        { "id": 'Guatemala', "name": "Guatemala" },
        { "id": 'Guayana Francesa', "name": "Guayana Francesa" },
        { "id": 'Guernsey', "name": "Guernsey" },
        { "id": 'Guinea', "name": "Guinea" },
        { "id": 'Guinea Ecuatorial', "name": "Guinea Ecuatorial" },
        { "id": 'Guinea-Bissau', "name": "Guinea-Bissau" },
        { "id": 'Guyana', "name": "Guyana" },
        { "id": 'Haití', "name": "Haití" },
        { "id": 'Honduras', "name": "Honduras" },
        { "id": 'Hungría', "name": "Hungría" },
        { "id": 'India', "name": "India" },
        { "id": 'Indonesia', "name": "Indonesia" },
        { "id": 'Irán', "name": "Irán" },
        { "id": 'Iraq', "name": "Iraq" },
        { "id": 'Irlanda', "name": "Irlanda" },
        { "id": 'Isla de la Ascensión', "name": "Isla de la Ascensión" },
        { "id": 'Isla de Man', "name": "Isla de Man" },
        { "id": 'Isla de Navidad', "name": "Isla de Navidad" },
        { "id": 'Isla Niue', "name": "Isla Niue" },
        { "id": 'Isla Norfolk', "name": "Isla Norfolk" },
        { "id": 'Islandia', "name": "Islandia" },
        { "id": 'Islas Åland', "name": "Islas Åland" },
        { "id": 'Islas Caimán', "name": "Islas Caimán" },
        { "id": 'Islas Canarias', "name": "Islas Canarias" },
        { "id": 'Islas Cocos (Keeling)', "name": "Islas Cocos (Keeling)" },
        { "id": 'Islas Cook', "name": "Islas Cook" },
        { "id": 'Islas Feroe', "name": "Islas Feroe" },
        { "id": 'Islas Georgias del Sur y Sandwich del Sur', "name": "Islas Georgias del Sur y Sandwich del Sur" },
        { "id": 'Islas Malvinas', "name": "Islas Malvinas" },
        { "id": 'Islas Marianas del Norte', "name": "Islas Marianas del Norte" },
        { "id": 'Islas Marshall', "name": "Islas Marshall" },
        { "id": 'Islas Pitcairn', "name": "Islas Pitcairn" },
        { "id": 'Islas Salomón', "name": "Islas Salomón" },
        { "id": 'Islas Turcas y Caicos', "name": "Islas Turcas y Caicos" },
        { "id": 'Islas UltramarinasMenores de Estados Unidos', "name": "Islas UltramarinasMenores de Estados Unidos" },
        { "id": 'Islas Vírgenes Británicas', "name": "Islas Vírgenes Británicas" },
        { "id": 'Islas Vírgenes de los Estados Unidos', "name": "Islas Vírgenes de los Estados Unidos" },
        { "id": 'Israel', "name": "Israel" },
        { "id": 'Italia', "name": "Italia" },
        { "id": 'Jamaica', "name": "Jamaica" },
        { "id": 'Japón', "name": "Japón" },
        { "id": 'Jersey', "name": "Jersey" },
        { "id": 'Jordania', "name": "Jordania" },
        { "id": 'Kazajistán', "name": "Kazajistán" },
        { "id": 'Kenia', "name": "Kenia" },
        { "id": 'Kirguistán', "name": "Kirguistán" },
        { "id": 'Kiribati', "name": "Kiribati" },
        { "id": 'Kosovo', "name": "Kosovo" },
        { "id": 'Kuwait', "name": "Kuwait" },
        { "id": 'Laos', "name": "Laos" },
        { "id": 'Lesoto', "name": "Lesoto" },
        { "id": 'Letonia', "name": "Letonia" },
        { "id": 'Líbano', "name": "Líbano" },
        { "id": 'Liberia', "name": "Liberia" },
        { "id": 'Libia', "name": "Libia" },
        { "id": 'Liechtenstein', "name": "Liechtenstein" },
        { "id": 'Lituania', "name": "Lituania" },
        { "id": 'Luxemburgo', "name": "Luxemburgo" },
        { "id": 'Macedonia', "name": "Macedonia" },
        { "id": 'Madagascar', "name": "Madagascar" },
        { "id": 'Malasia', "name": "Malasia" },
        { "id": 'Malaui', "name": "Malaui" },
        { "id": 'Maldivas', "name": "Maldivas" },
        { "id": 'Mali', "name": "Mali" },
        { "id": 'Malta', "name": "Malta" },
        { "id": 'Marruecos', "name": "Marruecos" },
        { "id": 'Martinica', "name": "Martinica" },
        { "id": 'Mauricio', "name": "Mauricio" },
        { "id": 'Mauritania', "name": "Mauritania" },
        { "id": 'Mayotte', "name": "Mayotte" },
        { "id": 'México', "name": "México" },
        { "id": 'Micronesia', "name": "Micronesia" },
        { "id": 'Moldavia', "name": "Moldavia" },
        { "id": 'Mónaco', "name": "Mónaco" },
        { "id": 'Mongolia', "name": "Mongolia" },
        { "id": 'Montenegro', "name": "Montenegro" },
        { "id": 'Montserrat', "name": "Montserrat" },
        { "id": 'Mozambique', "name": "Mozambique" },
        { "id": 'Myanmar (Birmania)', "name": "Myanmar (Birmania)" },
        { "id": 'Namibia', "name": "Namibia" },
        { "id": 'Nauru', "name": "Nauru" },
        { "id": 'Nepal', "name": "Nepal" },
        { "id": 'Nicaragua', "name": "Nicaragua" },
        { "id": 'Níger', "name": "Níger" },
        { "id": 'Nigeria', "name": "Nigeria" },
        { "id": 'Noruega', "name": "Noruega" },
        { "id": 'Nueva Caledonia', "name": "Nueva Caledonia" },
        { "id": 'Nueva Zelanda', "name": "Nueva Zelanda" },
        { "id": 'Omán', "name": "Omán" },
        { "id": 'Países Bajos', "name": "Países Bajos" },
        { "id": 'Pakistán', "name": "Pakistán" },
        { "id": 'Palaos', "name": "Palaos" },
        { "id": 'Panamá', "name": "Panamá" },
        { "id": 'Papúa Nueva Guinea', "name": "Papúa Nueva Guinea" },
        { "id": 'Paraguay', "name": "Paraguay" },
        { "id": 'Perú', "name": "Perú" },
        { "id": 'Polinesia Francesa', "name": "Polinesia Francesa" },
        { "id": 'Polonia', "name": "Polonia" },
        { "id": 'Portugal', "name": "Portugal" },
        { "id": 'Puerto Rico', "name": "Puerto Rico" },
        { "id": 'Qatar', "name": "Qatar" },
        { "id": 'Hong Kong', "name": "Hong Kong" },
        { "id": 'Macao', "name": "Macao" },
        { "id": 'Reino Unido', "name": "Reino Unido" },
        { "id": 'República Centroafricana', "name": "República Centroafricana" },
        { "id": 'República Checa', "name": "República Checa" },
        { "id": 'República Democrática del Congo', "name": "República Democrática del Congo" },
        { "id": 'República Dominicana', "name": "República Dominicana" },
        { "id": 'Reunión', "name": "Reunión" },
        { "id": 'Ruanda', "name": "Ruanda" },
        { "id": 'Rumanía', "name": "Rumanía" },
        { "id": 'Rusia', "name": "Rusia" },
        { "id": 'Sáhara Occidental', "name": "Sáhara Occidental" },
        { "id": 'Samoa', "name": "Samoa" },
        { "id": 'Samoa Americana', "name": "Samoa Americana" },
        { "id": 'San Bartolomé', "name": "San Bartolomé" },
        { "id": 'San Cristóbal y Nieves', "name": "San Cristóbal y Nieves" },
        { "id": 'San Marino', "name": "San Marino" },
        { "id": 'San Martín', "name": "San Martín" },
        { "id": 'San Pedro y Miquelón', "name": "San Pedro y Miquelón" },
        { "id": 'San Vicente y las Granadinas', "name": "San Vicente y las Granadinas" },
        { "id": 'Santa Elena', "name": "Santa Elena" },
        { "id": 'Santa Lucía', "name": "Santa Lucía" },
        { "id": 'Santo Tomé y Príncipe', "name": "Santo Tomé y Príncipe" },
        { "id": 'Senegal', "name": "Senegal" },
        { "id": 'Serbia', "name": "Serbia" },
        { "id": 'Seychelles', "name": "Seychelles" },
        { "id": 'Sierra Leona', "name": "Sierra Leona" },
        { "id": 'Singapur', "name": "Singapur" },
        { "id": 'Sint Maarten', "name": "Sint Maarten" },
        { "id": 'Siria', "name": "Siria" },
        { "id": 'Somalia', "name": "Somalia" },
        { "id": 'Sri Lanka', "name": "Sri Lanka" },
        { "id": 'Suazilandia', "name": "Suazilandia" },
        { "id": 'Sudáfrica', "name": "Sudáfrica" },
        { "id": 'Sudán', "name": "Sudán" },
        { "id": 'Sudán del Sur', "name": "Sudán del Sur" },
        { "id": 'Suecia', "name": "Suecia" },
        { "id": 'Suiza', "name": "Suiza" },
        { "id": 'Surinam', "name": "Surinam" },
        { "id": 'Svalbard y Jan Mayen', "name": "Svalbard y Jan Mayen" },
        { "id": 'Tailandia', "name": "Tailandia" },
        { "id": 'Taiwán', "name": "Taiwán" },
        { "id": 'Tanzania', "name": "Tanzania" },
        { "id": 'Tayikistán', "name": "Tayikistán" },
        { "id": 'Territorio Británico del Océano Índico', "name": "Territorio Británico del Océano Índico" },
        { "id": 'Territorios Australes Franceses', "name": "Territorios Australes Franceses" },
        { "id": 'Territorios Palestinos', "name": "Territorios Palestinos" },
        { "id": 'Timor Oriental', "name": "Timor Oriental" },
        { "id": 'Togo', "name": "Togo" },
        { "id": 'Tokelau', "name": "Tokelau" },
        { "id": 'Tonga', "name": "Tonga" },
        { "id": 'Trinidad y Tobago', "name": "Trinidad y Tobago" },
        { "id": 'Tristán de Acuña', "name": "Tristán de Acuña" },
        { "id": 'Túnez', "name": "Túnez" },
        { "id": 'Turkmenistán', "name": "Turkmenistán" },
        { "id": 'Turquía', "name": "Turquía" },
        { "id": 'Tuvalu', "name": "Tuvalu" },
        { "id": 'Ucrania', "name": "Ucrania" },
        { "id": 'Uganda', "name": "Uganda" },
        { "id": 'Uruguay', "name": "Uruguay" },
        { "id": 'Uzbekistán', "name": "Uzbekistán" },
        { "id": 'Vanuatu', "name": "Vanuatu" },
        { "id": 'Venezuela', "name": "Venezuela" },
        { "id": 'Vietnam', "name": "Vietnam" },
        { "id": 'Wallis y Futuna', "name": "Wallis y Futuna" },
        { "id": 'Yemen', "name": "Yemen" },
        { "id": 'Yibuti', "name": "Yibuti" },
        { "id": 'Zambia', "name": "Zambia" },
        { "id": 'Zimbabue', "name": "Zimbabue" }
    ],
    displayProp: (item) => item.name

}

export const SALE_EXECUTIVE = {
    items: [
        { id: '/users/19533b31-8aae-4f80-92d2-f1cc0424ac26', name: 'Alejandro Leonor' }
    ],
    displayProp: (item) => item.name
};

export const CUSTOMS_CLEARENCE_TYPES = {
    items: [
        { id: 'IMPORT', name: 'Importacion' },
        { id: 'EXPORT', name: 'Exportacion' }
    ],
    displayProp: (item) => item.name
};

export const APPLICABLE_INVOICE_ITEMS = {
    items: [ //
        { id: 'PEDIMENTO', name: 'Por Pedimento' },
        { id: 'CONTENEDOR/EQUIPO/LCL', name: 'Por Contenedor/Equipo/LCL' },
        { id: 'EMBARQUE/OPERACION', name: ' Por Embarque u Operación' },
        { id: 'FACTURA', name: ' Por Factura' },
        { id: 'DOCUMENTO', name: ' Por Documento' },
        { id: 'PARTIDA EXTRA', name: ' Por Partida Extra' },
        { id: 'DIA/HORA/EVENTO', name: ' Por Dia/Hora/Evento' },
        { id: 'BL/GUIA', name: ' Por BL o Guia' },
        { id: 'EQUIPO/CAJA/CAMION', name: ' Por Equipo/Caja/Camión' },
    ],
    displayProp: (item) => item.name
};

export const CUSTOM_STATUS_TYPES = {
    items: [
        { id: 'ENPROCESO', name: 'En Proceso' },
        { id: 'PREALERTADO', name: 'Prealertado' },
        { id: 'ALERTADO', name: 'Alertado' },
        { id: 'DESPACHADO', name: 'Despachado' },
        { id: 'CERRADO', name: 'Cerrado' }
    ],
    displayProp: (item) => item.name
};

export const VIA = {
    items: [
        { id: 'Terrestre', name: 'Terrestre' },
        { id: 'Aerea', name: 'Aerea' },
        { id: 'Maritima', name: 'Maritima' }
    ],
    displayProp: (item) => item.name
};

export const COLORS = {
    items: [
        { id: '#d67575', name: 'Rojo' },
        { id: '#55d', name: 'Azul' },
        { id: '#75d692', name: 'Verde' },
        { id: '#d6c075', name: 'Amarillo' },
        { id: '#a0a0a0', name: 'Negro' },
        { id: '#ff00ff', name: 'Magenta' }
    ],
    displayProp: (item) => item.name
};

export const USER_ROLES = {
    items: [
        { id: '0', name: 'Administrador' },
        { id: '1', name: 'Ejecutivo' },
        { id: '2', name: 'Operativo' },
        { id: '3', name: 'Documentador' },
        { id: '4', name: 'Finanzas' }
    ],
    displayProp: (item) => item.name
};

export const OWNOFFICE = {
    items: [
        { id: 'YES', name: 'SI' },
        { id: 'NO', name: 'NO' }
    ],
    displayProp: (item) => item.name
};

export const BILL_TYPES = [
    { id: '1', name: 'AAA SERVICIOS (+IVA) & GASTOS COMPROBADOS (SIN IVA) ' },
    { id: '2', name: 'AAA SERVICIOS (SIN IVA)  SOLAMENTE APLICABLE PARA CLIENTES EXTRANJERO' },
    { id: '3', name: 'AAA GASTOS COMPROBADOS *COMPLEMENTARIA/REMISION* (SIN IVA)' },
    { id: '4', name: 'AAA NOTAS DE CREDITO (SIN IVA)' },
    { id: '5', name: 'AAA NOTAS DE CREDITO (CON IVA)' },
    { id: '6', name: 'AFST FLETES NACIONALES  (+IVA - RET)' },
    { id: '7', name: 'AFST SERVICIO VARIOS (+IVA)' },
    { id: '8', name: 'AFST NOTAS DE CREDITO (SIN IVA)' },
    { id: '9', name: 'AFST NOTAS DE CREDITO (CON IVA)' }
];

export const COINS = [
    { id: 'MXN', name: 'Pesos (MXN)', singular: 'PESO (MXN)', plural: 'PESOS (MXN)' },
    { id: 'USD', name: 'Dolares (USD)', singular: 'DOLAR (USD)', plural: 'DOLARES (USD)' }
];



// WEBPACK FOOTER //
// ./data/selects.js